import { checkAuth, login } from '@/store/thunks/account';
import { TAccount } from '@/types/users';
import { deleteXDeviceCode, setXDeviceCode, X_DEVICE_CODE } from '@/utils/cookie';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TAccountState = {
    user: TAccount | undefined
    isLoading: boolean
}

const initialState: TAccountState = {
    isLoading: false,
    user: undefined,
};

export const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        setIsloading: (state) => {
            state.isLoading = true;
        },
        logout: (state) => {
            state.user = undefined;
            deleteXDeviceCode();
        },
        loginFailed: (state) => {
            deleteXDeviceCode();
            state.user = undefined;
            state.isLoading = false;
        },
        login: (state, action: PayloadAction<TAccount | undefined>) => {
            if (!action.payload) {
                state.isLoading = false;
                return;
            }
            if (action.payload[X_DEVICE_CODE]) {
                setXDeviceCode(action.payload[X_DEVICE_CODE]);
            }
            state.user = action.payload || undefined;
            state.isLoading = false;
        },
    },
    extraReducers: builder => {
        builder.addCase(login.pending, accountSlice.caseReducers.setIsloading);
        builder.addCase(login.fulfilled, accountSlice.caseReducers.login);
        builder.addCase(login.rejected, accountSlice.caseReducers.loginFailed);

        builder.addCase(checkAuth.pending, accountSlice.caseReducers.setIsloading);
        builder.addCase(checkAuth.fulfilled, accountSlice.caseReducers.login);
        builder.addCase(checkAuth.rejected, accountSlice.caseReducers.loginFailed);
    },
});

export const { logout } = accountSlice.actions;
